// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"521":"f558f43c318709268d00","524":"938f5b01bc7c4c323bf7"}[chunkId] + ".js";
};